export interface TaxValidationRequest {
  countryCode: string;
  taxId: string;
  postCode: string;
  companyName: string;
}

export enum TaxType {
  MEXICO = "MEXICO",
  ABN = "ABN",
  DEFAULT = "DEFAULT"
}

export interface TaxValidationResponse {
  validationStatus: ValidationStatus;
  message: string;
  validationResponseCode: ValidationResponseCode;
}

export type ValidationStatus = "Valid" | "Invalid" | "Pending" | "Error";

export enum ValidationResponseCode {
  InvalidCompanyName = "InvalidCompanyName",
  InvalidZipCode = "InvalidZipCode",
  InvalidCompanyNameAndZipCode = "InvalidCompanyNameAndZipCode",
  InvalidFormat = "InvalidFormat",
  RfcNotFound = "RfcNotFound",
  RfcNotRegistered = "RfcNotRegistered",
  UnknownValidationError = "UnknownValidationError",
  InvalidFormatForCountry = "InvalidFormatForCountry",
  AbnUnknownValidationError = "AbnUnknownValidationError",
  AbnInvalidFormat = "AbnInvalidFormat",
  AbnNotFound = "AbnNotFound",
  AbnCancelled = "AbnCancelled"
}
